import Header from '../../components/feature/Header';
import SEO from '../../components/feature/SEO';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ArtistsSection from './components/ArtistsSection';
import GallerySection from './components/GallerySection';
import ProcessSection from './components/ProcessSection';
import FlashCatalogSection from './components/FlashCatalogSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <SEO
        title="Rebel Rabbit — Tatuajes delicados femeninos en Providencia"
        description="Estudio exclusivo para mujeres en Las Urbinas 87, Oficina 26. Diseños finos, botánicos y lettering artístico. Agenda tu cita."
        keywords="tatuajes delicados, tatuajes femeninos, fine line, botánicos, lettering"
        ogTitle="Rebel Rabbit — Tatuajes delicados en Providencia"
        ogDescription="Tatuadoras profesionales especializadas en diseños finos y botánicos."
        ogImage="/images/og.svg"
        twitterTitle="Rebel Rabbit Tattoo Studio"
        twitterDescription="Estudio de tatuajes delicados en Providencia, Santiago"
      />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <ArtistsSection />
        <FlashCatalogSection />
        <GallerySection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
